import React, { FormEvent, useState } from 'react';
import {
  IonButton,
  IonCard,
  IonIcon,
  IonLoading,
  IonModal,
  IonTextarea
} from '@ionic/react';
import { star } from 'ionicons/icons';
import './AppRating.scss';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import EventBus from '../services/EventBus';
import { Laboratory } from '../models';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSkip?: () => void;
  laboratory: Laboratory;
}

const AppRating: React.FC<Props> = ({
  isOpen = true,
  onClose = () => {},
  onSkip,
  laboratory
}) => {
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState<number | null>(null);
  const [review, setReview] = useState('');
  const [hover, setHover] = useState<number | null>(null);
  const maxRating = 5;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();

    if (rating && !loading && laboratory) {
      setLoading(true);
      await AnalyticsRepository.review({ rating, review, laboratory });
      EventBus.success('Unilabs vous remercie pour votre avis !');
      setLoading(false);
    }

    setRating(null);
    setReview('');
    onClose();
  }

  return (
    <IonModal
      cssClass="c-app-rating modal-notification ion-padding"
      isOpen={isOpen}
      onDidDismiss={() => onClose()}
      swipeToClose={true}
    >
      <IonLoading isOpen={loading} />
      <IonCard>
        <form onSubmit={onSubmit} className="c-app-rating__inner ion-padding">
          <div className="ion-align-self-end">
            <button className="c-app-rating__skip" onClick={onSkip ?? onClose}>
              Passer
            </button>
          </div>
          <div className="ion-text-center">
            <h1>
              Avez-vous apprécié votre expérience
              <br />
              avec Le Pass&nbsp;?
            </h1>
          </div>
          <div style={{ flexShrink: 0 }} className="ion-margin-vertical">
            {[...Array(maxRating)].map((e, i) => (
              <button
                type="button"
                className={`c-app-rating__btn ${
                  i < (hover ?? 0) ? 'c-app-rating__btn--hover' : ''
                } ${i < (rating ?? 0) ? 'c-app-rating__btn--selected' : ''}`}
                key={i}
                onMouseEnter={() => {
                  setHover(i + 1);
                }}
                onMouseLeave={() => {
                  setHover(null);
                }}
                onClick={() => {
                  setRating(i + 1);
                }}
              >
                <IonIcon
                  className="c-app-rating__icon"
                  icon={star}
                  size="large"
                />
              </button>
            ))}
          </div>
          <div style={{ minWidth: '60%' }}>
            <IonTextarea
              className="custom-input"
              placeholder="Votre avis"
              onIonChange={(e) => {
                setReview(e.detail.value!);
              }}
            />
          </div>
          <IonButton
            disabled={!rating}
            className="ion-margin-top"
            type="submit"
          >
            Valider
          </IonButton>
        </form>
      </IonCard>
    </IonModal>
  );
};

export default AppRating;
